import React, { ReactNode } from 'react';

interface QuickAccessCardProps {
    icon: ReactNode;
    title: string;
    description: string;
    onClick: () => void;
    bgColor: string;
}

const QuickAccessCard: React.FC<QuickAccessCardProps> = ({ 
    icon, 
    title, 
    description, 
    onClick, 
    bgColor 
}) => (
    <div 
        className={`${bgColor} text-white rounded-lg shadow-md p-4 cursor-pointer transition-transform hover:scale-105`} 
        onClick={onClick}
    >
        <div className="flex items-center mb-2">
            {icon}
            <h3 className="text-lg font-bold ml-2">{title}</h3>
        </div>
        <p className="text-sm opacity-90">{description}</p>
    </div>
);

export default QuickAccessCard;